import '../../src/create_markup_bread_crumb_list'
import '../../src/jump_inner_link'
import '../../src/preview_buttons'
import '../../src/video_autoplay'
import Swiper from 'swiper/bundle'

const relatedStaffsMediaQuery = window.matchMedia('(min-width: 989px)')
const relatedStaffsPerView = 4
let relatedStaffsSwiper = null

function maxRelatedStaffsIndex() {
  if (!relatedStaffsSwiper) return 0

  return Math.max(relatedStaffsSwiper.slides.length - relatedStaffsPerView, 0)
}

function updateRelatedStaffsButtons(carousel) {
  const prevButton = carousel.querySelector('.staff-related-staffs__button--prev')
  const nextButton = carousel.querySelector('.staff-related-staffs__button--next')

  if (!relatedStaffsSwiper || !prevButton || !nextButton) return

  prevButton.classList.toggle('swiper-button-disabled', relatedStaffsSwiper.activeIndex <= 0)
  nextButton.classList.toggle('swiper-button-disabled', relatedStaffsSwiper.activeIndex >= maxRelatedStaffsIndex())
}

function handleRelatedStaffsButtonClick(event) {
  const button = event.target.closest('.staff-related-staffs__button')
  const carousel = event.currentTarget

  if (!button || !relatedStaffsSwiper || button.classList.contains('swiper-button-disabled')) return

  if (button.classList.contains('staff-related-staffs__button--prev')) {
    relatedStaffsSwiper.slideTo(Math.max(relatedStaffsSwiper.activeIndex - relatedStaffsPerView, 0))
  } else {
    relatedStaffsSwiper.slideTo(Math.min(relatedStaffsSwiper.activeIndex + relatedStaffsPerView, maxRelatedStaffsIndex()))
  }

  updateRelatedStaffsButtons(carousel)
}

function initializeRelatedStaffsSwiper() {
  const slider = document.querySelector('[data-staff-related-staffs]')
  const carousel = slider ? slider.closest('.staff-related-staffs__carousel') : null

  if (!slider || !carousel) return

  if (!relatedStaffsMediaQuery.matches) {
    if (relatedStaffsSwiper) {
      relatedStaffsSwiper.destroy(true, true)
      relatedStaffsSwiper = null
      carousel.removeEventListener('click', handleRelatedStaffsButtonClick)
    }
    return
  }

  if (relatedStaffsSwiper) return

  relatedStaffsSwiper = new Swiper(slider, {
    slidesPerView: relatedStaffsPerView,
    slidesPerGroup: 1,
    spaceBetween: 30,
    watchOverflow: true,
  })

  carousel.addEventListener('click', handleRelatedStaffsButtonClick)
  relatedStaffsSwiper.on('slideChange', () => updateRelatedStaffsButtons(carousel))
  relatedStaffsSwiper.on('resize', () => updateRelatedStaffsButtons(carousel))
  updateRelatedStaffsButtons(carousel)
}

document.addEventListener('DOMContentLoaded', () => {
  initializeRelatedStaffsSwiper()

  if (relatedStaffsMediaQuery.addEventListener) {
    relatedStaffsMediaQuery.addEventListener('change', initializeRelatedStaffsSwiper)
  } else {
    relatedStaffsMediaQuery.addListener(initializeRelatedStaffsSwiper)
  }

  document.querySelectorAll('[data-staff-assigned-galleries]').forEach((section) => {
    const moreButton = section.querySelector('[data-staff-assigned-galleries-more]')

    if (!moreButton) return

    moreButton.addEventListener('click', () => {
      section.querySelectorAll('[data-staff-assigned-gallery-item].is-hidden').forEach((item) => {
        item.classList.remove('is-hidden')
      })
      moreButton.remove()
    })
  })

  document.querySelectorAll('[data-staff-authored-articles]').forEach((section) => {
    const moreButton = section.querySelector('[data-staff-authored-articles-more]')

    if (!moreButton) return

    moreButton.addEventListener('click', () => {
      section.querySelectorAll('[data-staff-authored-article-item].is-hidden').forEach((item) => {
        item.classList.remove('is-hidden')
      })
      moreButton.remove()
    })
  })
})
